// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3caa1af","239":"1429930b","455":"e48b879e"}[chunkId] + ".chunk.js";
};